// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/**
 * SPDX-FileCopyrightText: 2019 Nextcloud GmbH and Nextcloud contributors
 * SPDX-License-Identifier: AGPL-3.0-or-later
 */
/**
 * SPDX-FileCopyrightText: 2021 Nextcloud GmbH and Nextcloud contributors
 * SPDX-License-Identifier: AGPL-3.0-or-later
 */
/*
* Ensure proper alignment of the vue material icons
*/
.material-design-icon[data-v-6be13bb0] {
  display: flex;
  align-self: center;
  justify-self: center;
  align-items: center;
  justify-content: center;
}
/*!
 * SPDX-FileCopyrightText: 2024 Nextcloud GmbH and Nextcloud contributors
 * SPDX-License-Identifier: AGPL-3.0-or-later
 */
.header-menu[data-v-6be13bb0] {
  position: relative;
  width: var(--header-height);
  height: var(--header-height);
}
.header-menu .header-menu__trigger[data-v-6be13bb0] {
  --button-size: var(--header-height) !important;
  height: var(--header-height);
  opacity: 0.85;
  filter: none !important;
  color: var(--color-background-plain-text, var(--color-primary-text)) !important;
}
.header-menu .header-menu__trigger[data-v-6be13bb0]:focus-visible {
  outline: none !important;
  box-shadow: none !important;
}
.header-menu--opened .header-menu__trigger[data-v-6be13bb0], .header-menu__trigger[data-v-6be13bb0]:hover, .header-menu__trigger[data-v-6be13bb0]:focus, .header-menu__trigger[data-v-6be13bb0]:active {
  opacity: 1;
}
@media only screen and (max-width: 512px) {
.header-menu[data-v-6be13bb0] {
    width: var(--default-clickable-area);
}
.header-menu .header-menu__trigger[data-v-6be13bb0] {
    --button-size: var(--default-clickable-area) !important;
}
}`, "",{"version":3,"sources":["webpack://./node_modules/@nextcloud/vue/dist/assets/NcHeaderButton-BPkJ5wxD.css"],"names":[],"mappings":"AAAA;;;EAGE;AACF;;;EAGE;AACF;;CAEC;AACD;EACE,aAAa;EACb,kBAAkB;EAClB,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;AACzB;AACA;;;EAGE;AACF;EACE,kBAAkB;EAClB,2BAA2B;EAC3B,4BAA4B;AAC9B;AACA;EACE,8CAA8C;EAC9C,4BAA4B;EAC5B,aAAa;EACb,uBAAuB;EACvB,+EAA+E;AACjF;AACA;EACE,wBAAwB;EACxB,2BAA2B;AAC7B;AACA;EACE,UAAU;AACZ;AACA;AACA;IACI,oCAAoC;AACxC;AACA;IACI,uDAAuD;AAC3D;AACA","sourcesContent":["/**\n * SPDX-FileCopyrightText: 2019 Nextcloud GmbH and Nextcloud contributors\n * SPDX-License-Identifier: AGPL-3.0-or-later\n */\n/**\n * SPDX-FileCopyrightText: 2021 Nextcloud GmbH and Nextcloud contributors\n * SPDX-License-Identifier: AGPL-3.0-or-later\n */\n/*\n* Ensure proper alignment of the vue material icons\n*/\n.material-design-icon[data-v-6be13bb0] {\n  display: flex;\n  align-self: center;\n  justify-self: center;\n  align-items: center;\n  justify-content: center;\n}\n/*!\n * SPDX-FileCopyrightText: 2024 Nextcloud GmbH and Nextcloud contributors\n * SPDX-License-Identifier: AGPL-3.0-or-later\n */\n.header-menu[data-v-6be13bb0] {\n  position: relative;\n  width: var(--header-height);\n  height: var(--header-height);\n}\n.header-menu .header-menu__trigger[data-v-6be13bb0] {\n  --button-size: var(--header-height) !important;\n  height: var(--header-height);\n  opacity: 0.85;\n  filter: none !important;\n  color: var(--color-background-plain-text, var(--color-primary-text)) !important;\n}\n.header-menu .header-menu__trigger[data-v-6be13bb0]:focus-visible {\n  outline: none !important;\n  box-shadow: none !important;\n}\n.header-menu--opened .header-menu__trigger[data-v-6be13bb0], .header-menu__trigger[data-v-6be13bb0]:hover, .header-menu__trigger[data-v-6be13bb0]:focus, .header-menu__trigger[data-v-6be13bb0]:active {\n  opacity: 1;\n}\n@media only screen and (max-width: 512px) {\n.header-menu[data-v-6be13bb0] {\n    width: var(--default-clickable-area);\n}\n.header-menu .header-menu__trigger[data-v-6be13bb0] {\n    --button-size: var(--default-clickable-area) !important;\n}\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
